import { graphql, useStaticQuery } from 'gatsby';

import Collapsible from 'react-collapsible';
import { Modal } from 'react-bootstrap';
import ModalComponent from './modal';
import React from 'react';
import closedIcon from '../../images/icons/collapsible-closed.svg';
import openIcon from '../../images/icons/collapsible-open.svg';
import styled from 'styled-components';

const BackgroundWrapper = styled.div`
	background-image: url(${(props) => props.bg});
	box-shadow: 0px 32px 102px rgba(23, 9, 40, 0.36);
	border-radius: 16px;
`;

const PopupChannels = ({ show, setShow, channelId }) => {
	const data = useStaticQuery(CHANNELS);

	const allData = getChannelsData(data, channelId);

	return (
		<>
			<ModalComponent show={show} setShow={setShow} dialogClassName="modal-popup">
				<BackgroundWrapper bg={data.bg.childImageSharp.fluid.src}>
					<Modal.Header>
						<Modal.Title id="custom-modal-styling-title" className="w-100">
							<div className="row w-100 d-flex justify-content-end">
								<span
									className="icon popup-close"
									onClick={() => {
										setShow(false);
									}}
								></span>
							</div>
						</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<div className="px-sm-5">
							<p>Виж всички твои</p>
							<h2 className="mb-4">Любими ТВ програми</h2>
						</div>

						{allData.map(({ title, channels }, index) => (
							<ChannelSection
								key={title + index}
								title={title}
								channels={channels}
								isInitiallyOpen={index === 0}
							/>
						))}
					</Modal.Body>
				</BackgroundWrapper>
			</ModalComponent>
		</>
	);
};

const ChannelSection = ({ title, channels, isInitiallyOpen }) => {
	return (
		<>
			<Collapsible
				open={isInitiallyOpen}
				trigger={<CollapsibleHeader isOpen={false} title={title} />}
				triggerWhenOpen={<CollapsibleHeader isOpen={true} title={title} />}
			>
				<ChannelRow channels={channels} isPopup={true} />
			</Collapsible>
		</>
	);
};

export const ChannelRow = ({ channels, isPopup }) => {
	return (
		<>
			{channels.length > 0 && (
				<div className="row">
					{channels.map(({ node }, index) => (
						<div
							key={index}
							className={
								'col-4 p-2 mb-5 d-flex justify-content-center ' +
								(isPopup ? 'col-sm-2' : 'col-sm-3')
							}
							
						>
							<img
								width={90}
								height={90}
								src={node.signedUrl[0]}
								alt="Канал"
							/>
						</div>
					))}
				</div>
			)}
		</>
	);
};

const CollapsibleHeader = ({ title, isOpen }) => {
	return (
		<>
			<div className="row w-100">
				<div className="d-inline-block w-100">
					<button className="clear" type="button">
						<img
							src={isOpen ? openIcon : closedIcon}
							className="d-inline-block"
							alt="Тригър"
						/>
						<h3 className={'d-inline-block pb-0'}>{title}</h3>
					</button>
					<hr className={'ml-5 collapsible channel-popup'} />
				</div>
			</div>
		</>
	);
};

export default PopupChannels;

const getChannelsData = (data, id) => {
	switch (id) {
		case '70':
			return [
				{
					title: 'Политематични',
					channels: data.channels70.edges.filter(({ node }) => {
						return node.name.includes('1. Политематични');
					})
				},
				{
					title: 'Новини',
					channels: data.channels70.edges.filter(({ node }) => {
						return node.name.includes('2. Новини');
					})
				},
				{
					title: 'Филми',
					channels: data.channels70.edges.filter(({ node }) => {
						return node.name.includes('3. Филми');
					})
				},
				{
					title: 'Детски',
					channels: data.channels70.edges.filter(({ node }) => {
						return node.name.includes('4. Детски');
					})
				},
				{
					title: 'Спорт',
					channels: data.channels70.edges.filter(({ node }) => {
						return node.name.includes('5. Спорт');
					})
				},
				{
					title: 'Хоби',
					channels: data.channels70.edges.filter(({ node }) => {
						return node.name.includes('6. Хоби Лайфстайл');
					})
				},
				{
					title: 'Музика',
					channels: data.channels70.edges.filter(({ node }) => {
						return node.name.includes('7. Музика');
					})
				},
				{
					title: 'Документални',
					channels: data.channels70.edges.filter(({ node }) => {
						return node.name.includes('8. Документални');
					})
				},
				{
					title: 'За възрастни (18+)',
					channels: data.channels70.edges.filter(({ node }) => {
						return node.name.includes('9. За възрастни (18+)');
					})
				},
				{
					title: 'Допълнителни',
					channels: data.channels70.edges.filter(({ node }) => {
						return node.name.includes('10. Допълнителни');
					})
				}
			];
		case '90':
			return [
				{
					title: 'Политематични',
					channels: data.channels90.edges.filter(({ node }) => {
						return node.name.includes('1. Политематични');
					})
				},
				{
					title: 'Новини',
					channels: data.channels90.edges.filter(({ node }) => {
						return node.name.includes('2. Новини');
					})
				},
				{
					title: 'Филми',
					channels: data.channels90.edges.filter(({ node }) => {
						return node.name.includes('3. Филми');
					})
				},
				{
					title: 'Детски',
					channels: data.channels90.edges.filter(({ node }) => {
						return node.name.includes('4. Детски');
					})
				},
				{
					title: 'Спорт',
					channels: data.channels90.edges.filter(({ node }) => {
						return node.name.includes('5. Спорт');
					})
				},
				{
					title: 'Хоби',
					channels: data.channels90.edges.filter(({ node }) => {
						return node.name.includes('6. Хоби Лайфстайл');
					})
				},
				{
					title: 'Музика',
					channels: data.channels90.edges.filter(({ node }) => {
						return node.name.includes('7. Музика');
					})
				},
				{
					title: 'Документални',
					channels: data.channels90.edges.filter(({ node }) => {
						return node.name.includes('8. Документални');
					})
				},
				{
					title: 'За възрастни (18+)',
					channels: data.channels90.edges.filter(({ node }) => {
						return node.name.includes('9. За възрастни (18+)');
					})
				},
				{
					title: 'Допълнителни',
					channels: data.channels90.edges.filter(({ node }) => {
						return node.name.includes('10. Допълнителни');
					})
				}
			];
		case '150':
			return [
				{
					title: 'Политематични',
					channels: data.channels150.edges.filter(({ node }) => {
						return node.name.includes('1. Политематични');
					})
				},
				{
					title: 'Новини',
					channels: data.channels150.edges.filter(({ node }) => {
						return node.name.includes('2. Новини');
					})
				},
				{
					title: 'Филми',
					channels: data.channels150.edges.filter(({ node }) => {
						return node.name.includes('3. Филми');
					})
				},
				{
					title: 'Детски',
					channels: data.channels150.edges.filter(({ node }) => {
						return node.name.includes('4. Детски');
					})
				},
				{
					title: 'Спорт',
					channels: data.channels150.edges.filter(({ node }) => {
						return node.name.includes('5. Спорт');
					})
				},
				{
					title: 'Хоби',
					channels: data.channels150.edges.filter(({ node }) => {
						return node.name.includes('6. Хоби Лайфстайл');
					})
				},
				{
					title: 'Музика',
					channels: data.channels150.edges.filter(({ node }) => {
						return node.name.includes('7. Музика');
					})
				},
				{
					title: 'Документални',
					channels: data.channels150.edges.filter(({ node }) => {
						return node.name.includes('8. Документални');
					})
				},
				{
					title: 'За възрастни (18+)',
					channels: data.channels150.edges.filter(({ node }) => {
						return node.name.includes('9. За възрастни (18+)');
					})
				},
				{
					title: 'Допълнителни',
					channels: data.channels150.edges.filter(({ node }) => {
						return node.name.includes('10. Допълнителни');
					})
				}
			];
		case '210':
			return [
				{
					title: 'Политематични',
					channels: data.channels210.edges.filter(({ node }) => {
						return node.name.includes('1. Политематични');
					})
				},
				{
					title: 'Новини',
					channels: data.channels210.edges.filter(({ node }) => {
						return node.name.includes('2. Новини');
					})
				},
				{
					title: 'Филми',
					channels: data.channels210.edges.filter(({ node }) => {
						return node.name.includes('3. Филми');
					})
				},
				{
					title: 'Детски',
					channels: data.channels210.edges.filter(({ node }) => {
						return node.name.includes('4. Детски');
					})
				},
				{
					title: 'Спорт',
					channels: data.channels210.edges.filter(({ node }) => {
						return node.name.includes('5. Спорт');
					})
				},
				{
					title: 'Хоби',
					channels: data.channels210.edges.filter(({ node }) => {
						return node.name.includes('6. Хоби Лайфстайл');
					})
				},
				{
					title: 'Музика',
					channels: data.channels210.edges.filter(({ node }) => {
						return node.name.includes('7. Музика');
					})
				},
				{
					title: 'Документални',
					channels: data.channels210.edges.filter(({ node }) => {
						return node.name.includes('8. Документални');
					})
				},
				{
					title: 'За възрастни (18+)',
					channels: data.channels210.edges.filter(({ node }) => {
						return node.name.includes('9. За възрастни (18+)');
					})
				},
				{
					title: 'Допълнителни',
					channels: data.channels210.edges.filter(({ node }) => {
						return node.name.includes('10. Допълнителни');
					})
				}
			];

		case '220':
			return [
				{
					title: 'Политематични',
					channels: data.channels220.edges.filter(({ node }) => {
						return node.name.includes('1. Политематични');
					})
				},
				{
					title: 'Новини',
					channels: data.channels220.edges.filter(({ node }) => {
						return node.name.includes('2. Новини');
					})
				},
				{
					title: 'Филми',
					channels: data.channels220.edges.filter(({ node }) => {
						return node.name.includes('3. Филми');
					})
				},
				{
					title: 'Детски',
					channels: data.channels220.edges.filter(({ node }) => {
						return node.name.includes('4. Детски');
					})
				},
				{
					title: 'Спорт',
					channels: data.channels220.edges.filter(({ node }) => {
						return node.name.includes('5. Спорт');
					})
				},
				{
					title: 'Хоби',
					channels: data.channels220.edges.filter(({ node }) => {
						return node.name.includes('6. Хоби Лайфстайл');
					})
				},
				{
					title: 'Музика',
					channels: data.channels220.edges.filter(({ node }) => {
						return node.name.includes('7. Музика');
					})
				},
				{
					title: 'Документални',
					channels: data.channels220.edges.filter(({ node }) => {
						return node.name.includes('8. Документални');
					})
				},
				{
					title: 'За възрастни (18+)',
					channels: data.channels220.edges.filter(({ node }) => {
						return node.name.includes('9. За възрастни (18+)');
					})
				},
				{
					title: 'Допълнителни',
					channels: data.channels220.edges.filter(({ node }) => {
						return node.name.includes('10. Допълнителни');
					})
				}
			];
		case '240az':
			return [
				{
					title: 'Политематични',
					channels: data.channels240az.edges.filter(({ node }) => {
						return node.name.includes('1. Политематични');
					})
				},
				{
					title: 'Новини',
					channels: data.channels240az.edges.filter(({ node }) => {
						return node.name.includes('2. Новини');
					})
				},
				{
					title: 'Филми',
					channels: data.channels240az.edges.filter(({ node }) => {
						return node.name.includes('3. Филми');
					})
				},
				{
					title: 'Детски',
					channels: data.channels240az.edges.filter(({ node }) => {
						return node.name.includes('4. Детски');
					})
				},
				{
					title: 'Спорт',
					channels: data.channels240az.edges.filter(({ node }) => {
						return node.name.includes('5. Спорт');
					})
				},
				{
					title: 'Хоби',
					channels: data.channels240az.edges.filter(({ node }) => {
						return node.name.includes('6. Хоби Лайфстайл');
					})
				},
				{
					title: 'Музика',
					channels: data.channels240az.edges.filter(({ node }) => {
						return node.name.includes('7. Музика');
					})
				},
				{
					title: 'Документални',
					channels: data.channels240az.edges.filter(({ node }) => {
						return node.name.includes('8. Документални');
					})
				},
				{
					title: 'За възрастни (18+)',
					channels: data.channels240az.edges.filter(({ node }) => {
						return node.name.includes('9. За възрастни (18+)');
					})
				},
				{
					title: 'Допълнителни',
					channels: data.channels240az.edges.filter(({ node }) => {
						return node.name.includes('10. Допълнителни');
					})
				}
			];
		case '240gold':
			return [
				{
					title: 'Политематични',
					channels: data.channels240gold.edges.filter(({ node }) => {
						return node.name.includes('1. Политематични');
					})
				},
				{
					title: 'Новини',
					channels: data.channels240gold.edges.filter(({ node }) => {
						return node.name.includes('2. Новини');
					})
				},
				{
					title: 'Филми',
					channels: data.channels240gold.edges.filter(({ node }) => {
						return node.name.includes('3. Филми');
					})
				},
				{
					title: 'Детски',
					channels: data.channels240gold.edges.filter(({ node }) => {
						return node.name.includes('4. Детски');
					})
				},
				{
					title: 'Спорт',
					channels: data.channels240gold.edges.filter(({ node }) => {
						return node.name.includes('5. Спорт');
					})
				},
				{
					title: 'Хоби',
					channels: data.channels240gold.edges.filter(({ node }) => {
						return node.name.includes('6. Хоби Лайфстайл');
					})
				},
				{
					title: 'Музика',
					channels: data.channels240gold.edges.filter(({ node }) => {
						return node.name.includes('7. Музика');
					})
				},
				{
					title: 'Документални',
					channels: data.channels240gold.edges.filter(({ node }) => {
						return node.name.includes('8. Документални');
					})
				},
				{
					title: 'За възрастни (18+)',
					channels: data.channels240gold.edges.filter(({ node }) => {
						return node.name.includes('9. За възрастни (18+)');
					})
				},
				{
					title: 'Допълнителни',
					channels: data.channels240gold.edges.filter(({ node }) => {
						return node.name.includes('10. Допълнителни');
					})
				}
			];

		default:
			return [
				{
					title: 'Политематични',
					channels: data.channels240gold.edges.filter(({ node }) => {
						return node.name.includes('1. Политематични');
					})
				},
				{
					title: 'Новини',
					channels: data.channels240gold.edges.filter(({ node }) => {
						return node.name.includes('2. Новини');
					})
				},
				{
					title: 'Филми',
					channels: data.channels240gold.edges.filter(({ node }) => {
						return node.name.includes('3. Филми');
					})
				},
				{
					title: 'Детски',
					channels: data.channels240gold.edges.filter(({ node }) => {
						return node.name.includes('4. Детски');
					})
				},
				{
					title: 'Спорт',
					channels: data.channels240gold.edges.filter(({ node }) => {
						return node.name.includes('5. Спорт');
					})
				},
				{
					title: 'Хоби',
					channels: data.channels240gold.edges.filter(({ node }) => {
						return node.name.includes('6. Хоби Лайфстайл');
					})
				},
				{
					title: 'Музика',
					channels: data.channels240gold.edges.filter(({ node }) => {
						return node.name.includes('7. Музика');
					})
				},
				{
					title: 'Документални',
					channels: data.channels240gold.edges.filter(({ node }) => {
						return node.name.includes('8. Документални');
					})
				},
				{
					title: 'За възрастни (18+)',
					channels: data.channels240gold.edges.filter(({ node }) => {
						return node.name.includes('9. За възрастни (18+)');
					})
				},
				{
					title: 'Допълнителни',
					channels: data.channels240gold.edges.filter(({ node }) => {
						return node.name.includes('10. Допълнителни');
					})
				}
			];
	}
};

const CHANNELS = graphql`
	query Channles {
		bg: file(relativePath: { eq: "popup-channels-bg.png" }) {
			childImageSharp {
				fluid(maxWidth: 2000) {
					src
				}
			}
		}
		channels70: allGoogleStorage(filter: { name: { regex: "/70/" } }) {
			edges {
				node {
					name
					signedUrl
				}
			}
		}
		channels90: allGoogleStorage(filter: { name: { regex: "/90/" } }) {
			edges {
				node {
					name
					signedUrl
				}
			}
		}
		channels150: allGoogleStorage(filter: { name: { regex: "/150/" } }) {
			edges {
				node {
					name
					signedUrl
				}
			}
		}
		channels210: allGoogleStorage(filter: { name: { regex: "/210/" } }) {
			edges {
				node {
					name
					signedUrl
				}
			}
		}
		channels220: allGoogleStorage(filter: { name: { regex: "/220/" } }) {
			edges {
				node {
					name
					signedUrl
				}
			}
		}
		channels240az: allGoogleStorage(filter: { name: { regex: "/240az/" } }) {
			edges {
				node {
					name
					signedUrl
				}
			}
		}
		channels240gold: allGoogleStorage(filter: { name: { regex: "/240gold/" } }) {
			edges {
				node {
					name
					signedUrl
				}
			}
		}
	}
`;

